import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { WebPage } from '../../shared/web-page';
import { MessageService } from 'primeng/components/common/messageservice';
import { ArquivoService } from '../../shared/services/arquivo.service';
import { ClinicaService } from '../clinica.service';

@Component({
  templateUrl: './visualizar-historico-clinica.component.html'
})
export class VisualizarHistoricoAnalisesClinicaComponent extends WebPage implements OnInit {

  idClinicaUnidade;
  clinica;
  clinicaUnidadeHistoricoList;

  constructor(
    private route: ActivatedRoute,
    private arquivoService: ArquivoService,
    private clinicaService: ClinicaService,
    messageService: MessageService
  ) {
    super(messageService);

    route.paramMap.subscribe(params =>
      this.idClinicaUnidade = params.get('idClinicaUnidade')
    );
  }

  ngOnInit() {
    this.isLoading = true;
    this.clinicaService.getHistorico(this.idClinicaUnidade)
      .finally(() => this.isLoading = false)
      .subscribe(
        historico => {
          console.log(historico);
          if (historico.length > 0) {
            this.clinica = historico[0].clinicaUnidade.clinica;
          }
          this.clinicaUnidadeHistoricoList = historico;
        },
        error => this.gerenciaErro(error)
      );
  }

  downloadTermoCredenciamento(idArquivo) {
    this.arquivoService.downloadArquivo(idArquivo, 'Termo_Credenciamento_Clinica');
  }
}



// WEBPACK FOOTER //
// ./src/app/components/clinica/visualizar-historico-clinica/visualizar-historico-clinica.component.ts